<template>
    <el-card>
        <!-- /* ---------------------------------- 搜索表单 ---------------------------------- */ -->
        <el-row>
            <el-form :model="form" :inline="true" :rules="{}">
                <el-form-item prop="merchantNo" :label="$t('clientmanage.table.merchantNo')">
                    <el-input v-model="form.merchantNo" />
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" type="success" @click="handleEmpty()">{{
                        $t('btns.empty')
                        }}</el-button>
                    <el-button size="mini" type="primary" @click="handleSearch()">{{
                        $t('btns.search')
                        }}</el-button>
                    <el-button size="mini" type="primary" v-if="permission.indexOf('add:merchantIp') > -1"
                        @click="handleEditor()">{{ $t('btns.add') }}
                    </el-button>
                </el-form-item>
            </el-form>
        </el-row>

        <!-- /* ---------------------------------- 表格数据 ---------------------------------- */ -->
        <el-row>
            <el-table :data="tableList" :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ textAlign: 'center' }" stripe>
                <el-table-column type="index" label="#" />
                <!-- <el-table-column :label="$t('merchantIp.label.id')" width="80" prop="id" /> -->
                <el-table-column :label="$t('merchantIp.label.merchantNo')" prop="merchantNo" />
                <el-table-column :label="$t('merchantIp.label.ipList')" prop="ipList" />
                <!-- <el-table-column :label="$t('merchantIp.label.createAcct')" prop="createAcct" />
                <el-table-column :label="$t('merchantIp.label.createTime')" width="200px" prop="createTime">
                    <template slot-scope="{ row }">
                        {{ row.createTime | asDayjs }}
                    </template>
                </el-table-column> -->
                <el-table-column :label="$t('merchantIp.label.updateAcct')" prop="updateAcct">
                </el-table-column>
                <el-table-column :label="$t('merchantIp.label.updateTime')" width="200px" prop="updateTime">
                    <template slot-scope="{ row }">
                        {{ row.updateTime | asDayjs }}
                    </template>
                </el-table-column>

                <el-table-column :label="$t('merchantIp.label.action')" width="220px">
                    <template slot-scope="{ row }">
                        <el-popconfirm :ref="`popover-${row.id}-1`" :key="`${row.id}-1`"
                            :title="$t('orders.tip.danger')" @confirm="handleDel(row)">
                            <el-button slot="reference" size="mini" type="danger"
                                v-if="permission.indexOf('merchantIp:delete') > -1">
                                {{ $t('btns.del') }}
                            </el-button>
                        </el-popconfirm>
                        <el-popconfirm :ref="`popover-${row.id}-2`" :key="`${row.id}-2`"
                            :title="$t('orders.tip.danger')" @confirm="handleEditor(row)">
                            <el-button slot="reference" size="mini" type="primary"
                                v-if="permission.indexOf('merchantIp:update') > -1">
                                {{ $t('btns.editor') }}
                            </el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <!-- /* ----------------------------------- 分页 ----------------------------------- */ -->
        <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />

        <!-- /* ----------------------------------- 编辑 ----------------------------------- */ -->
        <el-dialog :title="$t(`merchantIp.title.${isAdd ? 'add' : 'editor'}`)" :visible.sync="dialogVisible"
            width="40%">
            <el-row>
                <el-form :model="form1" v-bind="formProps.form1">
                    <el-form-item :prop="isAdd ? 'merchantNo' : ''" :label="$t('merchantIp.label.merchantNo')">

                        <el-autocomplete :disabled="!isAdd" style="width: 500px" v-model="form1.merchantNo"
                            :fetch-suggestions="querySearch" :placeholder="$t('clientmanage.addDialog.placeholdertext')"
                            @select="handleSelect" />


                        <!--            <el-select v-model="form1.merchantNo" style="width: 355px">-->
                        <!--              <el-option-->
                        <!--                v-for="item in merchantData"-->
                        <!--                :key="item.id"-->
                        <!--                :label="item.userName"-->
                        <!--                :value="item.userName"-->
                        <!--              />-->
                        <!--              <el-option :label="$t('btns.emptyValue')" value=""></el-option>-->
                        <!--            </el-select>-->
                    </el-form-item>
                    <el-form-item prop="ipList" :label="$t('merchantIp.label.ipList')">
                        <el-input v-model="form1.ipList" type="textarea" :autosize="{ minRows: 5, maxRows: 5}"
                            resize="none" />
                    </el-form-item>
                    <el-form-item prop="patchGoogleCode" :label="$t('merchantdeposit.label.googleDynamicCaptcha')">
                      <el-input v-model="form1.patchGoogleCode"  size="medium" />
                    </el-form-item>
                </el-form>
            </el-row>

            <el-row slot="footer">
                <el-button @click="dialogVisible = false">{{ $t('btns.cancel') }}</el-button>
                <el-button type="primary" @click="handleAdd"
                    v-if="isAdd && permission.indexOf('add:merchantIp') > -1">{{
                    $t('btns.confirm') }}
                </el-button>
                <el-button type="primary" @click="handleUpdate"
                    v-if="!isAdd && permission.indexOf('merchantIp:update') > -1">{{
                    $t('btns.confirm') }}</el-button>
            </el-row>
        </el-dialog>
    </el-card>
</template>

<script>
    import { mapGetters } from 'vuex';
    import merchantipApi from '@/api/merchantip';
    import { debounce } from 'lodash';
    import { isIp } from '@/utils/validate';
    import ordersApi from '@/api/orders';

    export default {
        name: 'merchantIp',
        data() {
            return {
                dialogVisible: false,
                isAdd: true,
                form: {
                    merchantNo: ''
                },
                form1: {
                    ipList: '',
                    merchantNo: '',
                    patchGoogleCode: ''
                },
                merchantData: [],
                tableData: {},
                pagination: {
                    no: 1,
                    size: this.$defaultPaginationSize
                },
                merchantName: ''
            };
        },
        computed: {
            ...mapGetters(['permission']),
            tableList() {
                return this.tableData.list || [];
            }
        },
        created() {
            this.init();
        },
        mounted() {
            this.getTableData();
            this.getMerchantData();
        },
        methods: {
            init() {
                this.handleSearch = debounce(this.getTableData, 200);
                this.handleAdd = debounce(this._handleAdd, 200);
                this.handleUpdate = debounce(this._handleUpdate, 200);

                this.formProps = {
                    form: {
                        ref: 'form',
                        'label-width': 'auto',
                        inline: true,
                        size: 'small',
                        rules: {
                            ipList: [
                                {
                                    required: true,
                                    message: this.$t('merchantIp.rules.ipList.required'),
                                    trigger: 'blur'
                                },
                                {
                                    validator: (rules, value, cb) => {
                                        if (!isIp(value)) {
                                            cb(new Error(this.$t('merchantIp.rules.ipList.isip')));
                                        }
                                    }
                                }
                            ],
                            merchantNo: [
                                {
                                    required: true,
                                    message: this.$t('merchantIp.rules.merchantNo.required'),
                                    trigger: 'blur'
                                }
                            ]
                        }
                    },
                    form1: {
                        ref: 'form1',
                        'label-width': 'auto',
                        inline: false,
                        size: 'small',
                        rules: {
                            ipList: [
                                {
                                    required: true,
                                    message: this.$t('merchantIp.rules.ipList.required'),
                                    trigger: 'blur'
                                },
                                {
                                    validator: (rules, value, cb) => {
                                        if (!isIp(value)) {
                                            cb(new Error(this.$t('merchantIp.rules.ipList.isip')));
                                        } else {
                                            cb();
                                        }
                                    }
                                }
                            ],
                            merchantNo: [
                                {
                                    required: true,
                                    message: this.$t('merchantIp.rules.merchantNo.required'),
                                    trigger: 'blur'
                                }
                            ],
                            patchGoogleCode: [
                              {
                                  required: true,
                                  message: this.$t('merchantdeposit.rules.googleDynamicCaptcha.required'),
                                  trigger: 'blur'
                              }
                          ]
                        }
                    }
                };
            },

            /* ---------------------------------- 格式化数据 --------------------------------- */
            formatParams() {
                return {
                    ...Object.keys(this.form).reduce((acc, key) => {
                        if (this.form[key] === 0 || this.form[key]) {
                            acc[key] = this.form[key];
                        }
                        return acc;
                    }, {})
                };
            },

            /* --------------------------------- 请求表格数据 --------------------------------- */
            async getTableData() {
                const { data } = await merchantipApi.getPage({
                    data: this.formatParams(),
                    params: this.pagination
                });
                if (data && data.code === 200) {
                    this.tableData = data.data || {};
                } else {
                    this.$message.error(data.msg);
                }
            },
            async getMerchantData() {
                const { data } = await ordersApi.getMerchantDataNew({ data: {} });
                if (data) {
                    if (data.code === 200) {
                        this.merchantData = data.data || {};
                    } else {
                        this.$message.error(data.msg);
                    }
                }
            },
            /* --------------------------------- 事件驱动函数 --------------------------------- */
            handleEmpty() {
                this.form = {
                    merchantNo: ''
                };
            },
            handleEditor(row) {
                if (row) {
                    this.isAdd = false;
                    this.form1.id = row.id;
                    this.form1.ipList = row.ipList;
                    this.form1.merchantNo = row.merchantNo;
                    this.form1.patchGoogleCode = '';
                } else {
                    this.isAdd = true;
                    this.form1 = {
                        ipList: '',
                        merchantNo: '',
                        patchGoogleCode: ''
                    };
                }
                this.dialogVisible = true;
            },
            _handleAdd() {
                this.$refs.form1.validate(async (valid) => {
                    if (valid) {
                        const { data } = await merchantipApi.doAdd(this.form1);
                        if (data && data.code === 200) {
                            this.$message.success(this.$t('status.success'));

                            this.dialogVisible = false;
                            this.isAdd = true;
                            this.getTableData();
                        } else {
                            this.$message.error(data.msg);
                        }
                    }
                });
            },
            _handleUpdate() {
                this.$refs.form1.validate(async (valid) => {
                    if (valid) {
                        const { data } = await merchantipApi.doUpdate(this.form1);
                        if (data && data.code === 200) {
                            this.$message.success(this.$t('status.success'));
                            this.dialogVisible = false;
                            this.isAdd = true;

                            this.getTableData();
                        } else {
                            this.$message.error(data.msg);
                        }
                    }
                });
            },

            handleDel(row) {
                const params = {
                    id: row.id
                };
                this.$confirm(this.$t('tips.tip1')).then(() => {
                    merchantipApi.doDelete(params).then(({ data }) => {
                        if (data.code === 200) {
                            this.$message.success(this.$t('status.success'));
                            this.getTableData();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                });
            },

            querySearch(queryString, cb) {
                const chants = this.merchantData.map((item) => ({
                    value: item.userName,
                    id: item.id
                }));
                const results = queryString ? chants.filter(this.createFilter(queryString)) : chants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (chant) => chant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
            },
            handleSelect(item) {
                // this.form1.merchantNo = item.id;
                console.log(item, this.form1.merchantNo);
            },

        }
    };
</script>

<style lang="scss" scoped>
    >.el-table th {
        overflow: visible;

        .cell {
            white-space: nowrap;
            text-overflow: clip;
            overflow: visible;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/merchantIp/index.vue